import DynamicDealsBanner from './DynamicDealsBanner';

export default DynamicDealsBanner;
